meedy.controller('meedy.patientVerifyCodePopupController', ['$rootScope', '$scope', '$mdDialog', 'resource', 'title',
    'meedy.termModel',
    function ($rootScope, $scope, $mdDialog, resource, title, termModel) {

        function setData() {
            $scope.title = title;
            $scope.forms = {
                code: null
            };

            $scope.resource = resource;
            $scope.verificationCode = "";
        }

        function setPermissions() {
        }

        function setListeners() {

        }

        function setActions() {
            $scope.save = function () {
                $scope.forms.code.$setSubmitted();
                if($scope.forms.code.$valid) {
                    var _verificationWrapper = {
                        idTerm: $scope.resource.id,
                        verificationCode: $scope.verificationCode
                    };

                    termModel.verifyAppointment(_verificationWrapper).then(function() {
                        $mdDialog.hide($scope.resource);
                    })
                }
            };

            $scope.cancel = function() {
                $mdDialog.cancel();
            };
        }

        function configureInterface() {

        }

        function initialize() {

        }

        setData();
        setPermissions();
        setListeners();
        setActions();
        configureInterface();
        initialize();
    }
]);
